import PropTypes from 'prop-types';
import React from 'react';
import { Provider } from 'react-redux';
import Routes from './routes';
import ZeckitTheme from './components/theme';

const Root = ({ store }) => (
  <Provider store={store}>
    <ZeckitTheme>
      <Routes />
    </ZeckitTheme>
  </Provider>
);

Root.propTypes = {
  store: PropTypes.object.isRequired,
};

export default Root;
